/**
 * @description Create listener for click outside of element `el` to execute callback `cb`
 * @param el Element to track click on
 * @param cb Callback
 * @param preventDefault Optional to prevent the default event
 * @returns Disposable function for listener (for unsubscription)
 */
export function clickOutside(el, cb, preventDefault = true) {
  // need for support desktop emulation
  const eventName = 'click';
  /**
   * @type {EventListener|undefined}
   */
  let listener;

  function expose() {
    listener = makeExposableListener(listener, eventName);
  }

  if (el) {
    listener = event => {
      if (isEventTriggeredOutsideElement(event, el)) {
        if (cb(event) === false) {
          expose();
        }

        if (preventDefault === true) {
          event.preventDefault();
        }
      }
    };

    setTimeout(() => {
      if (listener) {
        document.addEventListener(eventName, listener);
      }
    }, 0);

    return expose;
  }

  throw new Error('Missing required el');
}

/**
 * @description Create a function to unsubscribe listener
 * @param listener Listener to unsubscribe
 * @param eventName Event to unsubscribe
 * @returns Unsubscribed listener or undefined
 */
export function makeExposableListener(listener, eventName) {
  if (listener) {
    document.removeEventListener(eventName, listener);
    listener = undefined;
  }

  return listener;
}

/**
 * @description Check if event `event` is triggered outside of element `el`
 * @param event DOM event
 * @param el element to track click on
 * @returns `true` if triggered outside of element
 */
function isEventTriggeredOutsideElement(event, el){
  if (event.target && event.target instanceof Element) {
    let currElement = event.target;

    while (currElement.parentElement) {
      if (currElement === el) {
        return false;
      }

      currElement = currElement.parentElement;
    }

    return true;
  }

  return false;
}
